'use es6';

import NotificationMiddlewareBase from 'AdsUI/middleware/NotificationMiddlewareBase'; ///
//  Listens for all actions and if the action type is in the map
//  of notifications (or in the action.meta.notification itself)
//  we add dispatch an action to add to the
//  notification reducer.
//
//
//
//  Notification Object (Make record)
//
//  {
//    type: ['INFO' (default), 'SUCCESS', 'ERROR']
//    messageKey: '' //I18n key
//    message: '' // used if no i18n key
//    dismissalType: ['TIMEOUT' (default), 'EXPLICIT', NONE']
//    extras: {
//      timeoutLength: 5000ms //default?
//    }
//  }
//

const notificationMiddleware = actionNotificationHandlers => {
  return store => next => action => {
    NotificationMiddlewareBase({
      actionNotificationHandlers,
      action,
      dispatch: store.dispatch,
      getState: store.getState
    });
    return next(action);
  };
};

export default notificationMiddleware;